import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, KeyRound } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";

export default function StaffLogin() {
  const { login, verifyOtp } = useAuth();
  const nav = useNavigate();
  const [step, setStep] = useState("creds");
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [otp, setOtp] = useState("");
  const [hint, setHint] = useState("");
  const [loading, setLoading] = useState(false);

  const submitCreds = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const r = await login(email, pw);
      if (r.otp) {
        setStep("otp");
        setHint(r.dev_otp_hint || "");
        if (r.dev_otp_hint) {
          toast.success("OTP issued. Check email — dev hint also shown below until SES is configured.");
        } else {
          toast.success("OTP sent to your email. Please check your inbox.");
        }
      }
      else { toast.success("Welcome");
        if (r.user.role === "developer") nav("/developer");
        else if (r.user.role === "admin") nav("/admin");
        else nav("/shop-dashboard");
      }
    } catch (e) { toast.error(formatErr(e)); } finally { setLoading(false); }
  };
  const submitOtp = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const u = await verifyOtp(email, otp); toast.success("Authenticated");
      if (u.role === "developer") nav("/developer");
      else if (u.role === "admin") nav("/admin");
      else nav("/shop-dashboard");
    } catch (e) { toast.error(formatErr(e)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center p-6">
      <div className="w-full max-w-md card-luxe p-12 shadow-xl">
        <Link to="/" className="overline mb-6 block">← Back to site</Link>
        {step === "creds" ? (
          <>
            <Lock className="text-copper mb-5" size={28}/>
            <h1 className="font-display text-3xl text-dark">Staff Sign In</h1>
            <p className="text-sm text-gray-500 mt-2 mb-8">Authorized personnel only.</p>
            <form onSubmit={submitCreds} className="space-y-7">
              <input data-testid="staff-email" type="email" required placeholder="Email" className="input-luxe" value={email} onChange={(e)=>setEmail(e.target.value)}/>
              <input data-testid="staff-password" type="password" required placeholder="Password" className="input-luxe" value={pw} onChange={(e)=>setPw(e.target.value)}/>
              <button data-testid="staff-submit" disabled={loading} className="btn-primary w-full justify-center">{loading? "Verifying…" : "Continue"}</button>
            </form>
          </>
        ) : (
          <>
            <KeyRound className="text-copper mb-5" size={28}/>
            <h1 className="font-display text-3xl text-dark">Verify OTP</h1>
            <p className="text-sm text-gray-500 mt-2 mb-2">A 6-digit code has been sent to <span className="text-dark">{email}</span>. It expires in 5 minutes.</p>
            {hint && <div data-testid="otp-hint" className="text-[11px] text-copper bg-[#FAF7F2] border border-copper/30 px-3 py-2 mt-3 mb-3"><span className="text-gray-500">Dev OTP:</span> <span className="font-mono tracking-widest">{hint}</span></div>}
            <form onSubmit={submitOtp} className="space-y-7 mt-6">
              <input data-testid="otp-input" required maxLength={6} placeholder="000000" className="input-luxe text-center text-2xl tracking-[0.5em] font-mono" value={otp} onChange={(e)=>setOtp(e.target.value)}/>
              <button data-testid="otp-submit" disabled={loading} className="btn-primary w-full justify-center">{loading? "Verifying…" : "Sign in"}</button>
              <button type="button" onClick={()=>{setStep("creds"); setOtp("");}} className="block text-xs uppercase tracking-luxe text-gray-500 hover:text-dark mx-auto">← Use different account</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
